<template>
        <div class="d-flex flex-wrap p-0 m-0 col-xs-12 col-lg-10 col-xl-8 mb-3">

            <form-field :label="getFieldLabel('actNumber')"
                        class="col-xs-12 col-sm-3 p-0 mr-0 mr-sm-3 mb-3"
                        :value="object.actNumber"
                        :editable="isEditable('actNumber')"
                        :feedback="liveFeedback('actNumber')">
                <template #field>
                        <b-input
                            id="actNumber"
                            class="w-100"
                            placeholder="№"
                             v-model="$v.form.actNumber.$model"
                            :state="validateState('actNumber')">
                        </b-input>
                </template>
            </form-field>

            <date-time-picker class="col-xs-12 col-sm-6 col-md-4 mr-0 mr-sm-3 mb-2 p-0"
                      ref="actDate"
                      :title="getFieldLabel('actDate')"
                      name="actDate"
                      :editable="isEditable('actDate')"
                      :show-timepicker="false"
                      :date-required="false"
                      :key="getActDate() + '-a'"
                      :state="validateState('actDate')"
                      :initial-date-string="getActDate()"
                      @date-changed="onModelDateChanged" />

            <date-time-picker class="col-xs-12 col-sm-6 col-md-4 mr-0 mr-sm-3 mb-2 p-0"
                      ref="utilizationDate"
                      :title="getFieldLabel('utilizationDate')"
                      name="utilizationDate"
                      :editable="isEditable('utilizationDate')"
                      :show-timepicker="false"
                      :date-required="false"
                      :key="getUtilizationDate() + '-u'"
                      :state="validateState('utilizationDate')"
                      :initial-date-string="getUtilizationDate()"
                      @date-changed="onModelDateChanged" />

            <form-field :label="getFieldLabel('executorRepresentative')"
                        class="col-xs-12 col-sm-12 col-md-5 p-0 mr-0 mr-sm-3 mb-2"
                        :value="object.executorRepresentative"
                        :editable="isEditable('executorRepresentative')"
                        :feedback="liveFeedback('executorRepresentative')">
                <template #field>
                        <b-input type="text"
                            id="executorRepresentative"
                            v-model="$v.form.executorRepresentative.$model"
                            :state="validateState('executorRepresentative')">
                        </b-input>
                </template>
            </form-field>

            <form-field :label="getFieldLabel('executorPosition')"
                        class="col-xs-12 col-sm-12 col-md-5 p-0 mr-0 mr-sm-3 mb-2"
                        :value="object.executorPosition"
                        :editable="isEditable('executorPosition')"
                        :feedback="liveFeedback('executorPosition')">
                <template #field>
                        <b-input type="text"
                            id="executorPosition"
                            v-model="$v.form.executorPosition.$model"
                            :state="validateState('executorPosition')">
                        </b-input>
                </template>
            </form-field>


            <form-field :label="getFieldLabel('specialRepresentative')"
                        class="col-xs-12 col-sm-12 col-md-6 p-0 mr-0 mr-sm-3 mb-2"
                        :value="object.circumstances"
                        :editable="isEditable('specialRepresentative')"
                        :feedback="liveFeedback('specialRepresentative')">
                <template #field>
                        <b-input type="text"
                            id="specialRepresentative"
                            v-model="$v.form.specialRepresentative.$model"
                            :state="validateState('specialRepresentative')">
                        </b-input>
                </template>
            </form-field>

            <form-field :label="getFieldLabel('euthanasiaReason')"
                    class="required col-xs-12 p-0 mr-3 mt-3 mb-3"
                    :value="object.euthanasiaReasonText"
                    :editable="isEditable('euthanasiaReason')"
                    :feedback="liveFeedback('euthanasiaReason')">

                <template #field>
                    <radio-list  id="euthanasiaReason"
                                name="euthanasiaReason"
                                v-model="form.euthanasiaReason"
                                :url="euthanasiaReasonsUrl"
                                @radio-changed="onModelObjectRadioChanged" />
                </template>
            </form-field>

            <form-field :label="getFieldLabel('indicationReasons')"
                        class="col-xs-12 col-sm-12 col-md-6 p-0 mr-0 mr-sm-3 mb-2"
                        :value="object.indicationReasons"
                        :editable="isEditable('indicationReasons')"
                        :feedback="liveFeedback('indicationReasons')">
                <template #field>
                        <b-textarea
                            id="indicationReasons"
                            v-model="$v.form.indicationReasons.$model"
                            :state="validateState('indicationReasons')">
                        </b-textarea>
                </template>
            </form-field>

            <form-field :label="getFieldLabel('sedationMeds')"
                        class="col-xs-12 col-md-6 p-0 mr-0 mr-sm-3 mb-2"
                        :value="object.sedationMeds"
                        :editable="isEditable('sedationMeds')"
                        :feedback="liveFeedback('sedationMeds')">
                <template #field>
                    <div class="d-flex nowrap">
                        <b-input id="sedationMeds"
                            class="mr-1 flex-grow-1 col-8"
                            v-model="$v.form.sedationMeds.$model"
                            :state="validateState('sedationMeds')">
                        </b-input>

                        <div class="flex-grow-0 col-4 position-relative p-0 input-units">
                            <b-input id="sedationMedsQuantity"
                                v-model="$v.form.sedationMedsQuantity.$model"
                                :state="validateState('sedationMedsQuantity')">
                            </b-input>
                            <span class="units">мл</span>
                        </div>

                    </div>
                </template>
            </form-field>

            <form-field :label="getFieldLabel('lethalMeds')"
                        class="col-xs-12 col-md-5 p-0 mr-0 mr-sm-3 mb-2"
                        :value="object.lethalMeds"
                        :editable="isEditable('lethalMeds')"
                        :feedback="liveFeedback('lethalMeds')">
                <template #field>
                    <div class="d-flex nowrap">
                        <b-input id="lethalMeds"
                            class="mr-1 flex-grow-1 col-8"
                            v-model="$v.form.lethalMeds.$model"
                            :state="validateState('lethalMeds')">
                        </b-input>

                        <div class="flex-grow-0 col-4 position-relative p-0 input-units">
                            <b-input id="lethalMedsQuantity"
                                     v-model="$v.form.lethalMedsQuantity.$model"
                                     :state="validateState('lethalMedsQuantity')">
                            </b-input>
                            <span class="units">мл</span>
                        </div>
                    </div>
                </template>
            </form-field>


            <form-field :label="getFieldLabel('postMortem')"
                        class="col-xs-12 col-sm-12 col-md-8 p-0 mr-0 mr-sm-3 mb-2"
                        :value="object.postMortem"
                        :editable="isEditable('postMortem')"
                        :feedback="liveFeedback('postMortem')">
                <template #field>
                        <b-textarea
                            id="postMortem"
                            v-model="$v.form.postMortem.$model"
                            :state="validateState('postMortem')">
                        </b-textarea>
                </template>
            </form-field>

            <form-field :label="getFieldLabel('postMortemActNumber')"
                        class="col-xs-12 col-sm-4 p-0 mr-0 mr-sm-3 mb-3"
                        :value="object.postMortemActNumber"
                        :editable="isEditable('postMortemActNumber')"
                        :feedback="liveFeedback('postMortemActNumber')">
                <template #field>
                        <b-input
                            id="postMortemActNumber"
                            class="w-100"
                            placeholder="№"
                             v-model="$v.form.postMortemActNumber.$model"
                            :state="validateState('postMortemActNumber')">
                        </b-input>
                </template>
            </form-field>

            <date-time-picker class="col-xs-12 col-sm-6 col-md-5 mr-0 mr-sm-3 mb-2 p-0"
                      ref="postMortemActDate"
                      :title="getFieldLabel('postMortemActDate')"
                      name="postMortemActDate"
                      :editable="isEditable('postMortemActDate')"
                      :show-timepicker="false"
                      :date-required="false"
                      :state="validateState('postMortemActDate')"
                      :key="getPostMortemDate() + '-pm'"
                      :initial-date-string="getPostMortemDate()"
                      @date-changed="onModelDateChanged" />

            <date-time-picker class="col-xs-12 col-sm-6 col-md-4 col-lg-4 mr-0 mr-sm-3 mb-2 p-0"
                  ref="supportingDocumentDate"
                  :title="getFieldLabel('supportingDocumentDate')"
                  name="supportingDocumentDate"
                  :editable="isEditable('supportingDocumentDate')"
                  :show-timepicker="false"
                  :date-required="false"
                  :key="getSupportingDocumentDate() + '-s'"
                  :initial-date-string="getSupportingDocumentDate()"
                  :state="validateState('supportingDocumentDate')"
                  @date-changed="onModelDateChanged" />

            <form-field :label="getFieldLabel('supportingDocumentNumber')"
                        class="col-xs-12 col-sm-6 col-md-8 col-lg-6 p-0 mr-0 mr-sm-3 mb-2"
                        :value="object.supportingDocumentNumber"
                        :editable="isEditable('supportingDocumentNumber')"
                        :feedback="liveFeedback('supportingDocumentNumber')">
                <template #field>
                        <b-input type="text"
                            id="supportingDocumentNumber"
                            v-model="$v.form.supportingDocumentNumber.$model"
                            :state="validateState('supportingDocumentNumber')">
                        </b-input>
                </template>
            </form-field>

            <form-field :label="getFieldLabel('wasteDisposalOrganizationName')"
                        class="col-xs-12 col-md-8 p-0 mr-0 mr-sm-3 mb-2"
                        :value="object.wasteDisposalOrganizationName"
                        :editable="isEditable('wasteDisposalOrganizationName')"
                        :feedback="liveFeedback('wasteDisposalOrganizationName')">
                <template #field>
                        <b-input type="text"
                            id="wasteDisposalOrganizationName"
                            v-model="$v.form.wasteDisposalOrganizationName.$model"
                            :state="validateState('wasteDisposalOrganizationName')">
                        </b-input>
                </template>
            </form-field>


        </div>
</template>

<script>
    import FormField from "../../../../components/Forms/FormField";
    import DateTimePicker from "../../../../components/Forms/DateTimePicker";
    import DownloadButton from "../../../../components/Files/DownloadButton";
    import {ObjectComponentMixin} from "../../../../components/Forms/ObjectComponentMixin";
    import {todayStr} from "../../../../utils/dateFormat";
    import {EuthanasiaEventAttributes} from "./euthanasia";
    import {AttributeMixin} from "@/pages/AppPages/Events/AttributeMixin";
    import {mapGetters} from "vuex";
    import RadioList from "@/components/Select/RadioList.vue";
    import api from "@/api";
    import httpClient from "@/http";

    export default {
        name: "EuthanasiaAttributes",
        components: {RadioList, FormField, DateTimePicker, DownloadButton },
        mixins: [ObjectComponentMixin, AttributeMixin],
        data() {
            return {
                euthanasiaReasonTexts: {}
            }
        },
        computed: {
            ...mapGetters(['userFullName', 'userPosition']),
            euthanasiaReasonsUrl() {
                return api.events.euthanasiaReasons.list()
            }
        },
        methods: {
            getUtilizationDate() {
                return this.object.utilizationDate;
            },
            getPostMortemDate() {
                return this.object.postMortemActDate;
            },
            getActDate() {
                return this.object.actDate;
            },
            getSupportingDocumentDate() {
                return this.object.supportingDocumentDate;
            }
        },
        beforeMount() {
            this.objectClass = EuthanasiaEventAttributes;
            this.initialize();
            this.initObjectParams['utilizationDate'] = todayStr();
            this.initObjectParams['actDate'] = todayStr();
            this.initObjectParams['postMortemActDate'] = todayStr();
            this.initObjectParams['executorRepresentative'] = this.userFullName;
            this.initObjectParams['executorPosition'] = this.userPosition;
            this.initObjectParams['supportingDocumentDate'] = todayStr();

        },
        mounted() {
            const vm = this;
            vm.onMount();
            httpClient.get(this.euthanasiaReasonsUrl)
                .then((response) => {
                    vm.initObjectParams['euthanasiaReasons'] = response.data['results'];
                    vm.resetForm();
                })


        },
    }
</script>

<style scoped lang="scss">
    @import "node_modules/bootstrap/scss/functions";
    @import "node_modules/bootstrap/scss/variables";

    .input-units {
        & input.form-control.is-valid {
            background-image: none;
            padding-right: 0;
        }

        & .units {
            position:absolute;
            background-color: $input-bg;
            color: $secondary;
            width:32px;
            height: calc(100% - 2px);
            top: 1px;
            right: 10px;
            padding-top:6px;
            padding-left: 7px;
        }
    }


</style>